<div class="context-toast --{{ type }} --{{ animation }}">
    <h4 class="context-toast__title --paragraph" [innerHTML]="title"></h4>
    <p class="context-toast__description --m" [innerHTML]="message"></p>
</div>
